/**
 * Allergene aus der Karte (Antoine, 12.10.2026): „Die Allergene müssen aus der Karte entnommen
 * werden und sollen nicht immer manuell eingetragen werden müssen."
 *
 * Allergene hängen ausschließlich an `catalog_items`; eine Angebotsposition sieht sie nur über
 * ihre `catalogItemId`. Freitext-Positionen (Text einfügen, altes Angebot übernehmen) hatten
 * bisher immer `catalogItemId: null` und damit immer „Allergene fehlen". Diese Regel verknüpft
 * sie mit der Karte — aber NUR, wenn der Name eindeutig passt. Lieber keine Verknüpfung als die
 * falsche: falsche Allergene sind schlimmer als fehlende.
 *
 * Der Preis der Position wird hier nie angefasst — die Verknüpfung liefert nur die Datenbasis
 * (Allergene/Diät), der Betrag bleibt der aus Quelle bzw. Text.
 */

/** Gross-/Kleinschreibung und Leerraum spielen keine Rolle, sonst muss der Name exakt stimmen. */
export function normalisiereKartenname(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, " ");
}

/** Wie `normalisiereKartenname`, zusätzlich ohne Markdown-Sternchen und Doppelpunkt am Ende
 *  („**Vitello Tonnato**:" aus eingefügtem Text = „Vitello Tonnato" aus der Karte). */
export function normalisierePositionsname(name: string): string {
  return normalisiereKartenname(name.replace(/\*/g, "").replace(/:\s*$/, ""));
}

/**
 * Die EINE Katalog-Position, deren Name (normalisiert) exakt dem Positionsnamen entspricht.
 * `null` bei keinem Treffer, bei MEHREREN gleichnamigen Positionen (welche Allergene gälten?)
 * und bei Namen mit „oder" — „Fisch oder Fleisch" ist eine Wahl, keine einzelne Karten-Position,
 * und wird bewusst weder aufgeteilt noch verknüpft.
 */
export function findeKatalogTreffer<T extends { id: string; name: string }>(name: string, katalog: readonly T[]): T | null {
  if (/(^|\s)oder(\s|$)/i.test(name)) return null;
  const norm = normalisierePositionsname(name);
  if (!norm) return null;
  let treffer: T | null = null;
  for (const k of katalog) {
    if (normalisierePositionsname(k.name) !== norm) continue;
    if (treffer) return null; // mehrdeutig
    treffer = k;
  }
  return treffer;
}
